{
  "cms.access.adminRequired": "CMS-ylläpitäjän oikeudet vaaditaan.",
  "cms.shell.notifications": "Ilmoitukset",
  "cms.shell.title": "OMA+ sisällönhallinta",
  "cms.error.networkOrServer": "Verkko- tai palvelinvirhe. Yritä uudelleen hetken kuluttua.",
  "cms.error.publishFailedReconcileNeeded": "Julkaisu epäonnistui mutta sisältö saattaa silti olla julkaistu. Tarkista tila listauksesta.",
  "cms.error.staleDraft": "Luonnoksesta on tallennettu uudempi versio. Lataa nykyinen luonnos jatkaaksesi.",
  "cms.error.staleDraft.reload": "Lataa nykyinen luonnos",
  "cms.error.unknownShape": "Tuntematon sisältötyyppi.",
  "cms.status.draft": "Luonnos",
  "cms.status.published": "Julkaistu",
  "cms.aloitus.scheduled.empty": "Ei ajastettua sisältöä.",
  "cms.aloitus.scheduled.title": "Ajastetut sisällöt",
  "cms.sivupohjat.placeholder": "Sivupohjat lisätään myöhemmässä vaiheessa.",
  "cms.topBar.action.goToPublicPage": "Siirry sivulle",
  "cms.topBar.label": "Sisältötoiminnot"
}
